import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'
import { defaultQueryFilter } from '~/constants'

export const invoices = createQueryKeys('invoices', {
  all: (query?: any) => [query || defaultQueryFilter],
})

export type QueryKeys = inferQueryKeys<typeof invoices>
